import React, { useEffect } from 'react';

import { windowUseDesk } from 'application/components/widgets/SupportChat';
import { Outlet } from 'application/providers/RouterProvider';

import { ToastViewport } from '@shared/ui';

import styles from './index.module.scss';

const CleanLayout = () => {
  useEffect(() => {
    if (windowUseDesk.usedeskMessenger) {
      windowUseDesk.usedeskMessenger?.toggle(false);
    }
  }, [windowUseDesk.usedeskMessenger]);

  return (
    <div className={styles.CleanLayout}>
      <ToastViewport />
      <Outlet />
    </div>
  );
};

export default CleanLayout;
